<template>
  <w-settings-content-template side-title="장치 목록">
    <w-log-grid-menu slot="sideContent" ref="sideMenu" managetype-id="SMS" @load="loadData" @selectObjMenu="selectObjMenu"/>
    <div slot="content">
      <el-tabs type="card" v-model="activeTab" @tab-click="onChangeMenu">
        <el-tab-pane label="수집 설정" name="WFileSetting" class="h100 w100">
          <w-log-file-setting ref="applog" :selectPhysicalNode="selectPhysicalNode"></w-log-file-setting>
        </el-tab-pane>
        <el-tab-pane label="정책 설정" name="WFilteringSetting" class="h100 w100">
          <w-log-filtering-setting ref="filter" :selectPhysicalNode="selectPhysicalNode"></w-log-filtering-setting>
        </el-tab-pane>
      </el-tabs>
    </div>
  </w-settings-content-template>
</template>
<script>
import isNil from 'lodash/isNil';

import WSettingsContentTemplate from '@/components/template/SettingsContentTemplate';
import WLogGridMenu from '../Components/LogGridMenu';
import WLogFileSetting from './component/LogFileSetting';
import WLogFilteringSetting from './component/LogFilteringSetting';

export default {
  name: 'WAppLogSetting',
  components: {
    WLogFileSetting,
    WLogFilteringSetting,
    WLogGridMenu,
    WSettingsContentTemplate,
  },
  data() {
    return {
      activeTab: 'WFileSetting',
      title: '정책관리',
      nodeData: null,
      selectPhysicalNode: null,
      firstKey: null,
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    selectObjMenu(item) {
      this.selectPhysicalNode = item;
    },
    onChangeMenu() {
      if (!isNil(this.selectPhysicalNode)) {
        if (this.activeTab === 'WFileSetting') {
          this.$refs.applog.showLogListInGroup();
          this.$refs.applog.getLogCollector();
        } else {
          this.$refs.filter.loadData();
        }
      }
    },
    loadData() {
      this.nodeData = this.$refs.sideMenu.loadData();
      if (!isNil(this.nodeData)) {
        this.selectPhysicalNode = this.$refs.sideMenu.getSelectNode();
      }
    },
    onClickNode(data) {
      this.selectPhysicalNode = data;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/settings/log-analysis/Collect/Applog/index.vue